import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVerifiedUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.96851 4.67806C6.80171 5.01977 6 6.08997 6 7.30578V12.1613C6.00005 15.7035 7.11097 19.156 9.17534 22.0294C11.061 24.654 13.6548 26.6739 16.6421 27.857C17.1944 28.0756 17.8094 28.0756 18.3617 27.8568C21.348 26.6736 23.9408 24.6541 25.8257 22.0302C27.8894 19.1574 29 15.7059 29 12.1645V7.30521C29 6.08967 28.1987 5.01965 27.0323 4.67769L18.2757 2.11058C17.773 1.96321 17.2385 1.96314 16.7358 2.11038L7.96851 4.67806ZM23.0177 12.8788C23.4187 12.4778 23.4187 11.8277 23.0177 11.4267C22.6167 11.0257 21.9667 11.0257 21.5657 11.4267L16.5417 16.4506L13.9136 13.8226C13.5126 13.4216 12.8624 13.4216 12.4615 13.8226C12.0605 14.2236 12.0605 14.8736 12.4615 15.2746L15.8157 18.6288C16.2166 19.0298 16.8667 19.0298 17.2677 18.6288L23.0177 12.8788Z",
		fill: "#79C912"
	})
});
export default SvgVerifiedUser;
